import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import cx from 'classnames';
import { getNumericDeclension } from '@culture/common-helpers/string';

import LazyLoadImage from 'components/LazyLoad/Image';
import { NationalProjects } from 'components/Logos';

import Counter from './components/Counter';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { basePath }
} = getConfig();

const getExistingCounters = (counters, nationalStreamingCounters) => {
	const {
		broadcastCount,
		broadcastViews,
		nationalProjectCount,
		nationalProjectViews
	} = counters;

	const { all, projects } = nationalStreamingCounters;

	return {
		broadcastCount: all.broadcasts || broadcastCount,
		broadcastViews: all.views || broadcastViews,
		nationalProjectCount: projects.broadcasts || nationalProjectCount,
		nationalProjectViews: projects.views || nationalProjectViews
	};
};

const Counters = ({ counters, nationalStreamingCounters }) => {
	const {
		broadcastCount,
		broadcastViews,
		nationalProjectCount,
		nationalProjectViews
	} = getExistingCounters(counters, nationalStreamingCounters);
	const { growReport } = nationalStreamingCounters;
	const growReportText = growReport || 'в 5 раз';

	const currentYear = new Date().getFullYear().toString();
	const imageSrc = `${basePath}/images/live/subscribe_promo.jpg`;

	const numberWithSpaces = (number) =>
		number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');

	const broadcastDeclensionText = {
		single: 'трансляция',
		some: 'трансляции',
		many: 'трансляций'
	};

	const viewDeclensionText = {
		single: 'просмотр',
		some: 'просмотра',
		many: 'просмотров'
	};

	return (
		<div className={styles.promo}>
			<LazyLoadImage imageSrc={imageSrc}>
				<div
					className={styles.image}
					style={{ backgroundImage: `url(${imageSrc})` }}
				/>
			</LazyLoadImage>
			<div className={styles.content}>
				<div className={styles.brand}>
					<NationalProjects className={styles.icon} />
					<h1 className={styles.title}>
						Национальный проект
						<br />
						<span className={styles.name}>Культура</span>
					</h1>
				</div>
				<div className={styles.counters}>
					<div className={cx(styles.block, styles.blockTotal)}>
						Проведено всего
						<div className={styles.counters}>
							<Counter
								label={getNumericDeclension(
									broadcastCount,
									broadcastDeclensionText
								)}
								metrics={numberWithSpaces(broadcastCount)}
							/>
							<Counter
								label={getNumericDeclension(broadcastViews, viewDeclensionText)}
								metrics={numberWithSpaces(broadcastViews)}
							/>
						</div>
					</div>
					<Counter
						title="Рост просмотров"
						label={`за 2017–${currentYear} г.`}
						metrics={growReportText}
						className={styles.blockNational}
					/>
					<div className={cx(styles.block, styles.blockIncreasesViews)}>
						В рамках проекта
						<div className={styles.counters}>
							<Counter
								label={getNumericDeclension(
									nationalProjectCount,
									broadcastDeclensionText
								)}
								metrics={numberWithSpaces(nationalProjectCount)}
							/>
							<Counter
								label={getNumericDeclension(
									nationalProjectViews,
									viewDeclensionText
								)}
								metrics={numberWithSpaces(nationalProjectViews)}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const ItemCountersProps = PropTypes.shape({
	broadcasts: PropTypes.number,
	views: PropTypes.number
});

Counters.propTypes = {
	counters: PropTypes.shape({
		broadcastCount: PropTypes.number,
		broadcastViews: PropTypes.number,
		nationalProjectCount: PropTypes.number,
		nationalProjectViews: PropTypes.number
	}).isRequired,
	nationalStreamingCounters: PropTypes.shape({
		name: PropTypes.string,
		all: ItemCountersProps,
		projects: ItemCountersProps,
		growReport: PropTypes.string,
		entityType: PropTypes.string
	})
};

export default Counters;
